import { PropertyService } from '@modules/property/property-service';
import Errors from '@shared/error/errors';
import { routerAsync } from '@/app-module';
import Message from '@shared/message/message';
import { i18n } from '@shared/i18n';
import { update, get } from 'lodash';

export default {
  namespaced: true,

  state: {
    findLoading: false,
    saveLoading: false,
    record: null,
  },

  getters: {
    record: (state) => state.record,
    findLoading: (state) => !!state.findLoading,
    saveLoading: (state) => !!state.saveLoading,
  },

  mutations: {
    RESET(state) {
      state.findLoading = false;
      state.saveLoading = false;
      state.record = null;
    },

    FIND_STARTED(state) {
      state.record = null;
      state.findLoading = true;
    },

    FIND_SUCCESS(state, payload) {
      state.record = payload;
      state.findLoading = false;
    },

    FIND_ERROR(state) {
      state.record = null;
      state.findLoading = false;
    },

    CREATE_STARTED(state) {
      state.saveLoading = true;
    },

    CREATE_SUCCESS(state) {
      state.saveLoading = false;
    },

    CREATE_ERROR(state) {
      state.saveLoading = false;
    },

    UPDATE_STARTED(state) {
      state.saveLoading = true;
    },

    UPDATE_SUCCESS(state) {
      state.saveLoading = false;
    },

    UPDATE_ERROR(state) {
      state.saveLoading = false;
    },
  },

  actions: {
    doNew({ commit }) {
      commit('RESET');
    },
    
    async doGetNewId() {
     return await PropertyService.newId()
    },

    async doFind({ commit }, id) {
      try {
        commit('FIND_STARTED');

        const record = await PropertyService.find(id);

        const emails = get(record, 'managers', []).map(({email}) => email);
        update(record, 'emails', () => emails ) 

        commit('FIND_SUCCESS', record);
      } catch (error) {
        Errors.handle(error);
        commit('FIND_ERROR');
        routerAsync().push('/property/list');
      }
    },

    async doCreate({ commit }, {id, values}) {
      try {
        commit('CREATE_STARTED');
        await PropertyService.create(id, values);
        commit('CREATE_SUCCESS');
        Message.success(i18n('entities.property.create.success'));
        routerAsync().push('/property/list');
      } catch (error) {
        Errors.handle(error);
        commit('CREATE_ERROR');
      }
    },
    
    async doUpdate({ commit, dispatch, rootGetters }, { id, values, navigateOnSubmit = true }) {
      try {
        commit('UPDATE_STARTED');

        await PropertyService.update(id, values);
        dispatch('property/requirements/doFetch', {
          propertyId: id,
          userId: rootGetters['auth/currentUser'].id
        }, {
          root: true
        });

        commit('UPDATE_SUCCESS');
        Message.success(i18n('entities.property.update.success'));
        if (navigateOnSubmit) routerAsync().push('/property/list');
      } catch (error) {
        Errors.handle(error);
        commit('UPDATE_ERROR');
      }
    },
  },
};
